module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "mint-header mt-bColor-grey-lv5",
    class: [_vm.backgroundColor, _vm.color, {
      'is-fixed': _vm.fixed
    }],
    style: ({
      'font-size': _vm.fontSize,
      'height': _vm.height
    })
  }, [_c('div', {
    staticClass: "mint-header-button is-left"
  }, [_vm._t("left", [(_vm.router) ? _c('router-link', {
    attrs: {
      "to": _vm.to
    }
  }, [_c('span', {
    staticClass: "mint-header-button-left"
  }, [_c('i', {
    staticClass: "iconfont icon-keyboardarrowleft"
  }), _vm._v(_vm._s(_vm.leftIcontext))])]) : _vm._e()])], 2), _c('h1', {
    staticClass: "mint-header-title",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _c('div', {
    staticClass: "mint-header-button is-right"
  }, [_vm._t("right")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6492cf1b","hasScoped":false,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/header/src/header.vue
// module id = 401
// module chunks = 0